import cubejs from '@cubejs-client/core';
import { SignJWT } from 'jose';

const CUBE_API_URL = import.meta.env.VITE_CUBE_API_URL || 'http://localhost:4000/cubejs-api/v1';
const CUBE_API_SECRET = import.meta.env.VITE_CUBE_API_TOKEN || 'your-secret-key-min-32-characters-long-please-change-in-production';

// Debug: Log the configuration (remove in production)
console.log('Cube API URL:', CUBE_API_URL);
console.log('Cube API Secret (first 10 chars):', CUBE_API_SECRET?.substring(0, 10) + '...');

// Generate JWT token from API secret using browser-compatible jose library
// In production mode, Cube.js requires JWT tokens signed with the API secret
const generateToken = async () => {
  const secret = new TextEncoder().encode(CUBE_API_SECRET);
  const token = await new SignJWT({})
    .setProtectedHeader({ alg: 'HS256' })
    .setIssuedAt()
    .setExpirationTime('30d')
    .sign(secret);
  return token;
};

// Create Cube.js API instance
export const cubeApi = cubejs(
  generateToken,
  {
    apiUrl: CUBE_API_URL,
  }
);

export default cubeApi;
